<template>
<v-dialog max-width="1000px" persistent v-model="dialog" scrollable>
    <v-card>
    <v-toolbar dark>
        <v-toolbar-title class="headline">{{formTitle}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('setDialog', false) && $emit('setEditIndex',-1)">close</v-icon>
    </v-toolbar>

    <v-card-text style="height: auto;">
        <v-form ref="form" v-model="valid" lazy-validation> 
            <v-layout row>
                <v-flex xs6 class="mr-2">
                    <v-select :items="province_item" item-text="name" label="Province"></v-select>
                </v-flex>
                <v-flex xs6 class="mx-1">
                    <v-select :items="district_item" item-text="name" label="District"></v-select>
                </v-flex>
                <v-flex xs6 class="mr-2">
                    <v-select :items="sub_district_item" item-text="name" label="Sub district"></v-select>
                </v-flex>
            </v-layout> 
            <v-text-field label="Sub District Name TH"></v-text-field>
            <v-text-field label="Sub District Name EN"></v-text-field>
        </v-form>
    </v-card-text>
      <!-- <google-map></google-map> -->
    <v-divider></v-divider>
    <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" flat @click="$emit('setDialog', false) && $emit('setEditIndex',-1)">Cancel</v-btn>
        <v-btn color="green" flat>Save</v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
export default {
    props: ["dialog", "editedIndex"],
    data() {
        return {
            valid: true,
            province_item: [{
                name: 'ภูเก็ต',
                value: 1
            },
            {
                name: 'ตรัง',
                value: 2
            }],
            district_item: [{
                name: 'กะทู้',
                value: 1
            },
            {
                name: 'ราไวย์',
                value: 2
            }],
            sub_district_item: [{
                name: 'กะทู้',
                value: 1
            },
            {
                name: 'ป่าตอง',
                value: 2
            }]
        }
    },
    computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New sub district"
        : "Edit sub district";
    }
  }
}
</script>
<style>
</style>




